// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"LAYw0y_K","notClickable":"NgItQn1i"};